import React from 'react';
import { useLanguage } from '../locales/LanguageContext';

export const LanguageSwitcher = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={`inline-flex items-center bg-white/20 backdrop-blur-sm rounded-full p-0.5 ${className}`}>
      <button
        onClick={() => setLanguage('es')}
        className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200
          ${language === 'es'
            ? 'bg-white text-navy-900 shadow-sm'
            : 'text-white/80 hover:text-white'
          }`}
      >
        ES
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200
          ${language === 'en'
            ? 'bg-white text-navy-900 shadow-sm'
            : 'text-white/80 hover:text-white'
          }`}
      >
        EN
      </button>
    </div>
  );
};

export const LanguageSwitcherLight = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={`inline-flex items-center bg-slate-100 rounded-full p-0.5 ${className}`}>
      <button
        onClick={() => setLanguage('es')}
        className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200
          ${language === 'es'
            ? 'bg-navy-800 text-white shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
          }`}
      >
        ES
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200
          ${language === 'en'
            ? 'bg-navy-800 text-white shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
          }`}
      >
        EN
      </button>
    </div>
  );
};
